<template>
  <div>
    <b-card
      v-for="(anItem, i) in contacts"
      :title="anItem.title"
      @click="handleContactClick(anItem)"
      :key="`pl-${i}`"
      style="cursor: pointer; vert-align: middle"
    >
      <b-row>
        <b-col cols="4">
          <b-img
            v-bind="
              anItem.imgURL && anItem.imgURL.length > 0
                ? mainProps
                : mainPropsBlank
            "
            :src="assetsUrlHome + anItem.imgURL"
            rounded
            alt="Rounded image"
          />
        </b-col>
        <b-col cols="8">
          <b-card-text>
            {{ anItem.firstname }} {{ anItem.lastname }}
          </b-card-text>
          <b-card-text> {{ anItem.phone }} {{ anItem.email }} </b-card-text>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "CallLog_ContactsCardView",
  components: {},
  props: {
    resource: {
      type: Object,
      required: true
    },
    contacts: {
      type: Array,
      required: true
    }
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters({
      userData: "user/appsData",
      user: "user/user",
      profile: "user/profile"
    }),
    titleDate() {
      return "21 Medical Contacts"; //this.contact._created_at;
    }
  },
  methods: {
    handleContactClick(contact) {
      this.$emit("contact-clicked", contact);
    },
    handleOpenSideBar() {
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.$emit("close-clicked");
    },
    handleShowPlayList() {
      this.handleOpenSideBar();
    }
  },
  data() {
    return {
      sidebarId: "playlist-sidebar",
      sidebarModel: false,
      assetsUrlHome: "",
      /* SLIDE INFO*/
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      },
      mainPropsBlank: {
        //Possibly a better way to do this
        blank: true,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      },
      imgCBProps: {
        blank: false,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      },
      imgCBPropsBlank: {
        //Possibly a better way to do this
        blank: true,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
